import Env from "../base/env.js";
import Lenis from "@studio-freight/lenis";

export default class Smoothie {
  constructor() {
    this.DOM = {};
    // this.DOM.wrapper = document.querySelector('.jsSmoothWrapper')
    // this.DOM.content = document.querySelector('.jsSmoothContent')
    //
    //? Vars
    this.CAN_SMOOTH = Env.mobileCSS;
    this.VARS = {
      smooth: {
        inertia: 0.7,
        progress: 0,
        scrolltop: 0,
      },
    };
  }

  setup() {
    if (this.CAN_SMOOTH == false) {
      Env.smoothInstance = new Lenis({
        duration: this.VARS.smooth.inertia,
      });

      Env.smoothInstance.on("scroll", (e) => {
        // console.log(e);
      });

      function raf(time) {
        Env.smoothInstance.raf(time);
        requestAnimationFrame(raf);
      }

      requestAnimationFrame(raf);

      this.populate();
    }
  }

  populate() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        Env.smoothInstance.scrollTo(this.getAttribute("href"));
      });
    });
  }

  kill() {
    if (typeof Env.smoothInstance != "undefined") {
      // setTimeout(() => {
      console.log("smoother kil");
      // Env.smoothInstance.scrollTrigger.kill(false)
      Env.smoothInstance.kill();
      // }, 100);
    }
  }

  update() {
    if (typeof Env.smoothInstance != "undefined") {
      setTimeout(() => {
        console.log("smoother refresh");
        Env.smoothInstance.scrollTrigger.refresh();
      }, 100);
    }
  }

  reset() {
    if (typeof Env.smoothInstance != "undefined") {
      console.log("smoother reset");
      setTimeout(() => {
        this.kill();
      }, 100);
      setTimeout(() => {
        this.setup();
      }, 200);
    }
  }
}
